import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface AlertConfig {
  action?: () => void;
  actionLabel: string;
  description: string;
  image: string;
  innerId: string;
  title: string;
}

@Injectable({
  providedIn: 'root',
})
export class InterceptorService {
  private onAlertSubject = new BehaviorSubject<AlertConfig | null>(null);

  onAlert(): Observable<AlertConfig | null> {
    return this.onAlertSubject.asObservable();
  }

  showAlert(config: AlertConfig): void {
    this.onAlertSubject.next(config);
  }
}